<script>
export default {
  page: {
    title: 'Carregando...',
    meta: [{ name: 'description', content: 'Loading page...' }],
  },
}
</script>

<template>
  <Transition appear class="component-loading full-center">
    <BaseIcon :class="$style.loadingIcon" name="sync" spin />
  </Transition>
</template>

<style lang="sass" module>
.loadingIcon
  color: var(--v-primary-base)
  position: fixed
  z-index: 9999
  top: 0
  right: 0
</style>
